export default "__VITE_ASSET__DT$TIIgy__"